// Lane F — numbering configuration + ledger (backend djangoapp/urls_numbering.py, all under /bp/).
import Axios from 'axios';

const bp = '/bp';

const plantParams = (extra = {}) => {
  const plantId = localStorage.getItem('active_plant_id') || localStorage.getItem('plant_id');
  return plantId ? { plant_id: plantId, ...extra } : { ...extra };
};

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('Token') || ''}` });

const fail = (error) => {
  const data = error?.response?.data;
  return { status: 'failed', message: data?.message || error?.message || 'Request failed' };
};

export const list_number_formats = () =>
  Axios.get(`${bp}/numbering/formats/`, { params: plantParams(), headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const get_number_format = (kind) =>
  Axios.get(`${bp}/numbering/formats/${encodeURIComponent(kind)}/`, { params: plantParams(), headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const save_number_format = (body) =>
  Axios.post(`${bp}/numbering/formats/`, { ...plantParams(), ...body }, { headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const reset_number_format = (kind, change_reason) =>
  Axios.delete(`${bp}/numbering/formats/${encodeURIComponent(kind)}/`, { params: plantParams({ change_reason }), headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const get_numbering_catalog = () =>
  Axios.get(`${bp}/numbering/catalog/`, { headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const preview_number_format = (body) =>
  Axios.post(`${bp}/numbering/preview/`, { ...plantParams(), ...body }, { headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const lookup_gmp_number = (object_type, object_ref, kind) =>
  Axios.get(`${bp}/numbering/lookup/`, { params: { object_type, object_ref, ...(kind ? { kind } : {}) }, headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const list_number_assignments = (params) =>
  Axios.get(`${bp}/numbering/assignments/`, { params, headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);

export const void_number_assignment = (assignment_id, reason) =>
  Axios.post(`${bp}/numbering/void/`, { assignment_id, reason }, { headers: authHeaders() })
    .then((r) => r.data)
    .catch(fail);
